import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "play",
  "use": "play-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"play\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M1.5 8a6.5 6.5 0 1 1 13 0 6.5 6.5 0 0 1-13 0Zm9.35-.656a.75.75 0 0 1 0 1.312L7.114 10.73A.75.75 0 0 1 6 10.075v-4.15a.75.75 0 0 1 1.114-.656l3.736 2.075Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol